module.exports = __webpack_public_path__ + "static/media/popup-nomal-box.9974234e.png";